import React from 'react';

const EnhancedButton = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'medium', 
  disabled = false, 
  loading = false,
  icon = null,
  className = '',
  ...props 
}) => {
  const getVariantClass = () => {
    switch (variant) {
      case 'secondary': return 'btn-enhanced secondary';
      case 'success': return 'btn-enhanced success';
      case 'warning': return 'btn-enhanced warning';
      case 'error': return 'btn-enhanced error';
      default: return 'btn-enhanced';
    }
  };

  const getSizeClass = () => {
    switch (size) {
      case 'small': return 'btn-sm';
      case 'large': return 'btn-lg';
      default: return '';
    }
  };

  const handleClick = (e) => {
    if (!disabled && !loading && onClick) {
      onClick(e);
    }
  };

  return (
    <button
      className={`${getVariantClass()} ${getSizeClass()} ${className}`}
      onClick={handleClick}
      disabled={disabled || loading}
      {...props}
    >
      <div className="button-content">
        {loading ? (
          <div className="loading-content">
            <div className="spinner"></div>
            <span>Cargando...</span>
          </div>
        ) : (
          <>
            {icon && <span className="btn-icon">{icon}</span>}
            <span>{children}</span>
          </>
        )}
      </div>
    </button>
  );
};

export default EnhancedButton;
